const translations = {
  en: {
    navbar: {
      about: "About",
      experience: "Experience",
      projects: "Projects",
      skills: "Skills",
      contact: "Contact",
    },
    intro: {
      greeting: "Hi, I am",
      name: "Josue Rushanika",
      roles: [
        "Full-Stack Software Developer",
        "Cybersecurity Specialist",
        "Network Engineer",
      ],
      paragraph1:
        "I design and deliver fast, secure, and scalable web applications while managing and protecting complex IT infrastructures. My work focuses on turning business needs into clean, reliable solutions that create measurable value for users and organizations.",
      paragraph2:
        "I am currently open to full-time opportunities where I can contribute to modern products, collaborate with strong engineering teams, and keep growing my skills.",
      hireMe: "Hire me",
      seeProjects: "See projects",
    },
    about: {
      title: "About me",
      paragraph1:
        "Hello, I'm Josue Rushanika, a full-stack developer, cybersecurity specialist, and network engineer with hands-on experience in JavaScript, React, SQL, Redux, and Ruby on Rails. I focus on designing and delivering robust web applications that are maintainable, performant, and secure.",
      paragraph2:
        "Beyond application development, I work on server administration, network configuration, and troubleshooting to ensure that systems remain reliable and well protected. I'm currently exploring new technologies through personal projects and actively looking for a full-time role where I can add meaningful value and continue growing. I also enjoy contributing to open-source projects.",
    },
    highlights: {
      eyebrow: "Why work with me",
      title: "How I create value",
      items: [
        {
          title: "Product-focused engineering",
          body: "I design, build, and ship full-stack features that solve real business problems, not just write code.",
        },
        {
          title: "Security at the core",
          body: "With hands-on cybersecurity and VAPT experience, I help teams ship secure systems from day one.",
        },
        {
          title: "End-to-end delivery",
          body: "From infrastructure and networking to UI/UX and mobile, I can own features across the entire stack.",
        },
      ],
    },
    experience: {
      eyebrow: "Professional Experience",
      title: "Experience",
      items: [
        {
          id: 5,
          title: "Solution Architect",
          company: "Innova Shield · Part-time",
          timeframe: "Dec 2022 - Present",
          bullets: [
            "Led end-to-end solution design and architecture, delivering scalable, secure, and highly available systems across web, mobile, and enterprise environments.",
            "Designed and architected modern web and mobile applications using React Native and Next.js, with a focus on performance, scalability, and security by design.",
            "Defined application security architectures and conducted web, mobile, and desktop application penetration testing to identify vulnerabilities and enforce secure development practices.",
            "Designed and validated network and infrastructure security architectures, performing network penetration testing, segmentation, and implementing defense-in-depth strategies.",
            "Architected and integrated enterprise cybersecurity solutions, including IDS, IPS, and Next-Generation Firewalls (NGFW), to detect, prevent, and respond to security threats.",
            "Designed secure network topologies and system integrations, ensuring reliable and secure communication between applications, infrastructure, and enterprise services.",
          ],
        },
        {
          id: 0,
          title: "Cyber Security Specialist & Web Developer",
          company: "Diolichat",
          timeframe: "Feb 2025 - Feb 2026",
          bullets: [
            "Develop and maintain secure web and mobile applications, from user interface to deployment.",
            "Perform Vulnerability Assessment and Penetration Testing (VAPT) on applications and infrastructure to identify and remediate security weaknesses.",
          ],
        },
        {
          id: 1,
          title: "Cyber Security Specialist & Web Developer",
          company: "COM Agency · Part-time",
          timeframe: "Oct 2024 - Apr 2025",
          bullets: [
            "Managed and secured Windows environments and Active Directory in line with security best practices.",
            "Optimized network security, including Next-Generation Firewalls, and led incident response activities.",
            "Conducted penetration testing using tools such as Kali Linux, Burp Suite, and Metasploit.",
            "Developed custom web solutions using HTML, CSS, JavaScript, and React.",
          ],
        },
        {
          id: 2,
          title: "Cyber Security Specialist",
          company: "RDtech",
          timeframe: "Mar 2024 - Oct 2024",
          bullets: [
            "Managed threat intelligence using Cisco Talos to anticipate and mitigate attacks.",
            "Oversaw firewalls, routers, and servers across Windows, Linux, O365, and Azure environments.",
            "Implemented IDS/IPS systems and performed penetration testing with Kali Linux.",
            "Configured SIEM platforms (Splunk, Wazuh) and contributed to web, network security, and IoT projects.",
            "Supported GPS solutions and SQL Server maintenance.",
          ],
        },
        {
          id: 3,
          title: "Network Engineer and Web Developer",
          company: "White-Foundation",
          timeframe: "Sep 2021 - Oct 2023",
          bullets: [
            "Performed vulnerability assessments and penetration testing to strengthen security posture.",
            "Developed cybersecurity policies and managed network infrastructure including firewalls, routers, and VPNs.",
            "Administered Windows and Linux servers and network devices (Cisco, Mikrotik, TP-Link).",
            "Managed Active Directory, DHCP, and access control systems.",
            "Built custom web solutions using HTML, CSS, JavaScript, React, SQL, and Ruby on Rails.",
          ],
        },
        {
          id: 4,
          title: "Network Engineer Intern",
          company: "Sipernet (ISP)",
          timeframe: "Jan 2021 - Jul 2021",
          bullets: [
            "Configured Cisco equipment, PBX phone systems, and maintained server hardware.",
            "Installed and configured Nanostations, Rocket antennas, AirFiber, Mikrotik, routers, and switches (Cisco, Huawei, Mikrotik, D-Link, TP-Link).",
            "Installed and configured Dell servers and Windows Server 2012 R2.",
          ],
        },
      ],
    },
    projects: {
      eyebrow: "Selected Work",
      title: "My Projects",
    },
    projectsButtons: {
      demo: "live",
      live: "Live",
      code: "Code",
    },
    projectsContent: {
      23: {
        title: "VMware Virtualization",
        description:
          "I design, deploy, and manage virtualized infrastructures using VMware technologies such as vSphere and ESXi, enabling efficient server consolidation, high availability, and secure multi-tenant environments for modern applications.",
      },
    },
    skills: {
      title: "Skills & Technologies",
      body:
        "My toolbox includes JavaScript, React, React Native, Redux, Node.js, and Express for building modern web and mobile interfaces and back-end services, as well as Ruby on Rails, MySQL, PostgreSQL, MongoDB, Firebase, and AI/ML for robust cloud-powered systems. I'm also comfortable with Git, Linux, and Docker and have a strong interest in cybersecurity and UI/UX design. Let's build something great together.",
    },
    callToAction: {
      eyebrow: "Let's build something impactful",
      title: "Open to full-time roles & selective freelance work",
      body:
        "Whether you're a company looking for a pragmatic engineer or a client who needs a secure, production-ready solution, I can help you design, build, and ship reliably.",
      emailMe: "Email me",
      viewProjects: "View projects",
    },
    contact: {
      title: "Let's work together",
      body:
        "Whether you have a question, a project in mind, or just want to say hello, feel free to reach out. I'll get back to you as soon as possible.",
      nameLabel: "Name",
      emailLabel: "Email address",
      messageLabel: "Message",
      messagePlaceholder: "Your message here...",
      submitting: "Sending...",
      submit: "Submit",
    },
    chat: {
      headerTitle: "Chat with Josue",
      headerSubtitle: "Typically replies quickly",
      introName: "Josue Rushanika",
      introMessageLine1: "Hi! 👋",
      introMessageLine2: "How can I help you?",
      startButton: "Start WhatsApp conversation",
      redirectNote: "You'll be redirected to WhatsApp.",
      defaultMessage:
        "Hello Josue, let’s connect and build something great together.",
    },
    splash: {
      loadingLabel: "Loading portfolio",
      portfolio: "Portfolio",
      loadingExperience: "Loading experience",
    },
    common: {
      languageToggleLabel: "Toggle language",
      languageShort: {
        en: "EN",
        fr: "FR",
      },
    },
  },
  fr: {
    navbar: {
      about: "À propos",
      experience: "Expérience",
      projects: "Projets",
      skills: "Compétences",
      contact: "Contact",
    },
    intro: {
      greeting: "Bonjour, je suis",
      name: "Josue Rushanika",
      roles: [
        "Développeur Full-Stack",
        "Spécialiste en cybersécurité",
        "Ingénieur réseau",
      ],
      paragraph1:
        "Je conçois et livre des applications web rapides, sécurisées et évolutives tout en gérant et en protégeant des infrastructures informatiques complexes. Mon travail vise à transformer les besoins métier en solutions fiables et propres qui apportent une réelle valeur aux utilisateurs et aux organisations.",
      paragraph2:
        "Je suis actuellement ouvert à des opportunités à plein temps où je peux contribuer à des produits modernes, collaborer avec des équipes d'ingénierie solides et continuer à développer mes compétences.",
      hireMe: "Embauchez-moi",
      seeProjects: "Voir les projets",
    },
    about: {
      title: "À propos de moi",
      paragraph1:
        "Bonjour, je suis Josue Rushanika, développeur full-stack, spécialiste en cybersécurité et ingénieur réseau avec une expérience pratique en JavaScript, React, SQL, Redux et Ruby on Rails. Je me concentre sur la conception et la mise en place d'applications web robustes, maintenables, performantes et sécurisées.",
      paragraph2:
        "Au-delà du développement d'applications, je travaille sur l'administration de serveurs, la configuration réseau et le dépannage afin de garantir des systèmes fiables et bien protégés. J'explore actuellement de nouvelles technologies à travers des projets personnels et je suis activement à la recherche d'un poste à plein temps où je peux apporter une valeur significative et continuer à progresser. J'aime également contribuer à des projets open source.",
    },
    highlights: {
      eyebrow: "Pourquoi travailler avec moi",
      title: "Comment je crée de la valeur",
      items: [
        {
          title: "Un ingénierie orientée produit",
          body: "Je conçois, développe et livre des fonctionnalités full-stack qui résolvent de vrais problèmes métier, pas seulement du code.",
        },
        {
          title: "La sécurité au cœur",
          body: "Avec une expérience pratique en cybersécurité et en tests d'intrusion, j'aide les équipes à livrer des systèmes sécurisés dès le premier jour.",
        },
        {
          title: "Livraison de bout en bout",
          body: "De l'infrastructure et des réseaux jusqu'à l'interface utilisateur et le mobile, je peux prendre en charge des fonctionnalités sur l'ensemble de la pile.",
        },
      ],
    },
    experience: {
      eyebrow: "Expérience professionnelle",
      title: "Expérience",
      items: [
        {
          id: 5,
          title: "Architecte de solutions",
          company: "Innova Shield · Temps partiel",
          timeframe: "Déc 2022 - Présent",
          bullets: [
            "Conception et pilotage de solutions de bout en bout, en livrant des systèmes web, mobiles et d'entreprise évolutifs, sécurisés et hautement disponibles.",
            "Conception et architecture d'applications web et mobiles modernes avec React Native et Next.js, en mettant l'accent sur la performance, l'évolutivité et la sécurité dès la conception.",
            "Définition d'architectures de sécurité applicative et réalisation de tests d'intrusion (web, mobile et desktop) pour identifier les vulnérabilités et renforcer les pratiques de développement sécurisé.",
            "Conception et validation d'architectures de sécurité réseau et d'infrastructure, incluant des tests d'intrusion réseau, la segmentation et des stratégies de défense en profondeur.",
            "Architecture et intégration de solutions de cybersécurité d'entreprise, incluant IDS, IPS et pare-feux de nouvelle génération (NGFW), pour détecter, prévenir et répondre aux menaces.",
            "Conception de topologies réseau sécurisées et d'intégrations système, garantissant une communication fiable et sécurisée entre applications, infrastructures et services d'entreprise.",
          ],
        },
        {
          id: 0,
          title: "Spécialiste en cybersécurité & Développeur Web",
          company: "Diolichat",
          timeframe: "Mars 2025 - Présent",
          bullets: [
            "Développer et maintenir des applications web et mobiles sécurisées, de l'interface utilisateur au déploiement.",
            "Réaliser des tests de vulnérabilité et de pénétration (VAPT) sur les applications et l'infrastructure afin d'identifier et de corriger les faiblesses de sécurité.",
          ],
        },
        {
          id: 1,
          title: "Spécialiste en cybersécurité & Développeur Web",
          company: "COM Agency · Temps partiel",
          timeframe: "Oct 2024 - Avr 2025",
          bullets: [
            "Gestion et sécurisation des environnements Windows et d'Active Directory conformément aux bonnes pratiques de sécurité.",
            "Optimisation de la sécurité réseau, y compris des pare-feux de nouvelle génération, et pilotage des activités de réponse aux incidents.",
            "Réalisation de tests d'intrusion avec des outils tels que Kali Linux, Burp Suite et Metasploit.",
            "Développement de solutions web sur mesure avec HTML, CSS, JavaScript et React.",
          ],
        },
        {
          id: 2,
          title: "Spécialiste en cybersécurité",
          company: "RDtech",
          timeframe: "Mars 2024 - Oct 2024",
          bullets: [
            "Gestion du renseignement sur les menaces avec Cisco Talos pour anticiper et atténuer les attaques.",
            "Supervision des pare-feux, routeurs et serveurs dans des environnements Windows, Linux, O365 et Azure.",
            "Mise en œuvre de systèmes IDS/IPS et réalisation de tests d'intrusion avec Kali Linux.",
            "Configuration de plateformes SIEM (Splunk, Wazuh) et contribution à des projets de sécurité web, réseau et IoT.",
            "Support des solutions GPS et de la maintenance de SQL Server.",
          ],
        },
        {
          id: 3,
          title: "Ingénieur réseau et Développeur Web",
          company: "White-Foundation",
          timeframe: "Sep 2021 - Oct 2023",
          bullets: [
            "Réalisation d'analyses de vulnérabilité et de tests de pénétration pour renforcer la posture de sécurité.",
            "Élaboration de politiques de cybersécurité et gestion de l'infrastructure réseau incluant pare-feux, routeurs et VPN.",
            "Administration de serveurs Windows et Linux et d'équipements réseau (Cisco, Mikrotik, TP-Link).",
            "Gestion d'Active Directory, DHCP et des systèmes de contrôle d'accès.",
            "Développement de solutions web sur mesure avec HTML, CSS, JavaScript, React, SQL et Ruby on Rails.",
          ],
        },
        {
          id: 4,
          title: "Stagiaire Ingénieur Réseau",
          company: "Sipernet (FAI)",
          timeframe: "Jan 2021 - Juil 2021",
          bullets: [
            "Configuration d'équipements Cisco, de systèmes téléphoniques PBX et maintenance du matériel serveur.",
            "Installation et configuration de Nanostations, antennes Rocket, AirFiber, Mikrotik, routeurs et commutateurs (Cisco, Huawei, Mikrotik, D-Link, TP-Link).",
            "Installation et configuration de serveurs Dell et de Windows Server 2012 R2.",
          ],
        },
      ],
    },
    projects: {
      eyebrow: "Projets sélectionnés",
      title: "Mes projets",
    },
    projectsButtons: {
      demo: "Démo",
      live: "Démo",
      code: "Code",
    },
    projectsContent: {
      25: {
        title: "Nabahya Food Institute (NFI)",
        description:
          "J'ai refactorisé et mis à jour le site officiel de Nabahya Food Institute (NFI), avec une personnalisation complète du site, des mises à jour du contenu, l'optimisation des performances et l'amélioration des fonctionnalités. La plateforme a été alignée sur la vision stratégique du président et les besoins de l'organisation, tout en renforçant la présence numérique et la crédibilité de l'institut auprès des partenaires, investisseurs et parties prenantes.",
        tags: ["Développement web", "Optimisation des performances"],
      },
      1: {
        title: "Novafarm AI",
        description:
          "Novafarm AI est une application mobile qui exploite l'intelligence artificielle et le machine learning pour fournir aux agriculteurs des informations en temps réel, des recommandations personnalisées et des solutions basées sur les données afin d'améliorer les rendements, d'optimiser les ressources et d'augmenter la productivité agricole globale.",
      },
      2: {
        title: "Rwanda-Conference",
        description:
          "Rwanda-Conference est un site vitrine dédié à un événement, permettant aux participants et aux organisateurs d'accéder au programme, aux intervenants, aux informations de lieu, ainsi qu'aux détails d'inscription à partir d'un point central.",
      },
      3: {
        title: "WEB SITE",
        description:
          "Une application monopage (SPA) développée avec React (Vite) à partir d'une maquette Figma, mettant l'accent sur une interface moderne et réactive.",
      },
      4: {
        title: "budget-app",
        description:
          "Application web mobile pour gérer son budget : les utilisateurs peuvent suivre leurs transactions par catégorie et visualiser clairement combien ils dépensent et dans quels domaines.",
      },
      5: {
        title: "Movies App",
        description:
          "Une application de films qui affiche différentes listes selon la catégorie choisie et permet d'ajouter des likes, des commentaires, ainsi que de réserver un film. Construite avec une API, JavaScript, Webpack, HTML et CSS.",
      },
      6: {
        title: "Space Travelers Hub",
        description:
          "Space Travelers Hub est une application React qui offre une expérience immersive d'exploration spatiale. Les utilisateurs peuvent parcourir une liste de fusées, de dragons et de missions, réserver ou annuler leurs réservations et gérer les éléments qu'ils ont rejoints.",
      },
      7: {
        title: "COVID country health app",
        description:
          "Une application de suivi COVID par pays, utilisant une API pour afficher les dernières statistiques sur les cas, décès et guérisons, avec des données mises à jour en temps réel pour chaque région.",
      },
      8: {
        title: "Math Magician",
        description:
          "Math Magician est une application web simple qui génère des problèmes mathématiques aléatoires pour les utilisateurs. Elle est construite avec React afin d'offrir une interface utilisateur fluide et moderne.",
      },
      9: {
        title: "To-do list",
        description:
          "Application de liste de tâches permettant d'organiser et de gérer ses activités : création de tâches, définition des priorités, suivi de l'avancement et accomplissement des objectifs dans un délai donné.",
      },
      10: {
        title: "Geo_map_call_app",
        description:
          "Application React qui combine fonctionnalités de géolocalisation et visioconférence en temps réel. Les utilisateurs peuvent explorer une carte, voir des lieux d'intérêt et lancer des sessions vidéo avec d'autres utilisateurs à des emplacements spécifiques.",
      },
      11: {
        title: "GPS Tracking System",
        description:
          "Système de suivi GPS basé sur Traccar, utilisé pour surveiller en temps réel la localisation de véhicules ou d'actifs, améliorer la gestion de flotte, la logistique et la sécurité grâce à des alertes et des rapports détaillés.",
      },
      12: {
        title: "Doctors Appointments",
        description:
          "Frontend React pour une application de prise de rendez-vous médicaux. L'application est responsive et permet aux utilisateurs de charger, créer et supprimer des médecins et des réservations. Les utilisateurs doivent se créer un compte ou se connecter pour accéder à l'application.",
      },
      13: {
        title: "CCNA",
        description:
          "CCNA (Cisco Certified Network Associate) est une certification de Cisco, l'un des leaders mondiaux dans la fabrication et la vente d'équipements réseau.",
      },
      14: {
        title: "GNS3",
        description:
          "Simulation d'un réseau d'entreprise dans GNS3, combinant réseaux physiques et virtuels. Elle permet de connecter utilisateurs et systèmes vers le data center et le cloud, tout en fournissant un accès aux données et à l'analytique réseau.",
      },
      15: {
        title: "Cyber",
        description:
          "En tant que consultant en cybersécurité, je conseille et mets en œuvre des mesures pour protéger les systèmes et les données contre les menaces de sécurité.",
      },
      16: {
        title: "Splunk",
        description:
          "J'utilise Splunk, une plateforme puissante pour rechercher, surveiller et analyser en temps réel les données machine, afin d'obtenir des insights, détecter les menaces de sécurité et améliorer l'efficacité opérationnelle.",
      },
      17: {
        title: "Wazuh",
        description:
          "J'utilise Wazuh, une plateforme de sécurité open source qui fournit détection des menaces, visibilité, conformité et réponse aux incidents via l'analyse de logs, la détection d'intrusion et l'évaluation des vulnérabilités.",
      },
      18: {
        title: "Sophos",
        description:
          "J'utilise Sophos, une solution de cybersécurité qui offre une protection avancée contre les menaces, incluant pare-feu, antivirus, chiffrement et sécurité des endpoints pour protéger réseaux, appareils et données.",
      },
      19: {
        title: "ManageEngine",
        description:
          "J'utilise ManageEngine, une suite logicielle de gestion informatique intégrée qui fournit des outils pour gérer réseaux, serveurs, applications, endpoints et sécurité, afin d'optimiser les opérations IT et l'efficacité.",
      },
      20: {
        title: "Office",
        description:
          "J'utilise Microsoft 365 (O365), une suite de productivité cloud incluant Word, Excel, PowerPoint, Outlook et des services comme OneDrive et Teams, facilitant la collaboration et la gestion documentaire, avec intégration à Active Directory pour la gestion des accès.",
      },
      21: {
        title: "script",
        description:
          "Une collection de scripts Python pour les ingénieurs réseau que j'utilise au quotidien afin d'automatiser des tâches et simplifier l'administration des infrastructures.",
      },
      22: {
        title: "nessus",
        description:
          "J'utilise Nessus, un outil de gestion des vulnérabilités largement utilisé pour analyser réseaux, systèmes et applications, aider à identifier les failles de sécurité et prioriser les remédiations.",
      },
      23: {
        title: "Virtualisation VMware",
        description:
          "Je conçois, déploie et gère des infrastructures virtualisées en utilisant les technologies VMware telles que vSphere et ESXi, permettant une consolidation efficace des serveurs, une haute disponibilité et des environnements multi-locataires sécurisés pour les applications modernes.",
      },
    },
    skills: {
      title: "Compétences & Technologies",
      body:
        "Ma boîte à outils comprend JavaScript, React, React Native, Redux, Node.js et Express pour créer des interfaces web et mobiles modernes ainsi que des services back-end, ainsi que Ruby on Rails, MySQL, PostgreSQL, MongoDB, Firebase et l'IA/ML pour des systèmes cloud robustes. Je suis également à l'aise avec Git, Linux et Docker, et j'ai un fort intérêt pour la cybersécurité et le design UI/UX. Construisons quelque chose de remarquable ensemble.",
    },
    callToAction: {
      eyebrow: "Construisons quelque chose d'impactant",
      title: "Ouvert aux postes à plein temps & missions freelance sélectives",
      body:
        "Que vous soyez une entreprise à la recherche d'un ingénieur pragmatique ou un client ayant besoin d'une solution sécurisée et prête pour la production, je peux vous aider à concevoir, développer et livrer avec fiabilité.",
      emailMe: "M'écrire",
      viewProjects: "Voir les projets",
    },
    contact: {
      title: "Travaillons ensemble",
      body:
        "Que vous ayez une question, un projet en tête ou que vous souhaitiez simplement dire bonjour, n'hésitez pas à me contacter. Je vous répondrai dès que possible.",
      nameLabel: "Nom",
      emailLabel: "Adresse e-mail",
      messageLabel: "Message",
      messagePlaceholder: "Votre message...",
      submitting: "Envoi...",
      submit: "Envoyer",
    },
    chat: {
      headerTitle: "Discuter avec Josue",
      headerSubtitle: "Répond généralement rapidement",
      introName: "Josue Rushanika",
      introMessageLine1: "Bonjour ! 👋",
      introMessageLine2: "Comment puis-je vous aider ?",
      startButton: "Démarrer la conversation WhatsApp",
      redirectNote: "Vous serez redirigé vers WhatsApp.",
      defaultMessage:
        "Bonjour Josue, échangeons et construisons quelque chose de remarquable ensemble.",
    },
    splash: {
      loadingLabel: "Chargement du portfolio",
      portfolio: "Portfolio",
      loadingExperience: "Chargement de l'expérience",
    },
    common: {
      languageToggleLabel: "Changer de langue",
      languageShort: {
        en: "EN",
        fr: "FR",
      },
    },
  },
};

export default translations;
